

import { computed, ref } from 'vue'
import moment from 'moment';
import {FilterMatchMode, FilterOperator} from "primevue/api";
import router from "@/router";
import {useToast} from "primevue/usetoast";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import { useConfirm } from "primevue/useconfirm";
import {BaoCaoVeSinhNuocSach} from "@/models/baoCaoVeSinhNuocSach";
import CDCRepository from "@/services/CDCRepository";


export default {
  setup() {
    const confirm = useConfirm();
    const toast = useToast();
    const store = useStore();
    const date = ref();
    const service = ref("");
    const router = useRouter();
    const baoCao = ref({} as BaoCaoVeSinhNuocSach);
    console.log("####################@@@@@@@@@@@@@@@@@@@@@ baoCaoCoSoLaoDong aaaa: ");
    const initDb = () => {
      baoCao.value.keQuaKTVSDuoiMotNgans = [
        {tenDonVi: "Cơ sở cung cấp nước < 1000 m3/ngđ"},
        {tenDonVi: "Đơn vị có bể chứa nước tập trung"},
      ];
      baoCao.value.keQuaKTVSNhaVSCCs = [
        {loaiCongTrinh: "Trường học, nhà trẻ.."},
        {loaiCongTrinh: "Trạm Y tế"},
        {loaiCongTrinh: "UBND xã/ phường"},
        {loaiCongTrinh: "Chợ"},
        {loaiCongTrinh: "Bến xe"},
        {loaiCongTrinh: "Nhà ga"},
        {loaiCongTrinh: "Công viên, khu vui chơi"},
        {loaiCongTrinh: "Loại khác"},
      ];
      baoCao.value.thongKeNhaTieuHoGiaDinhs = [
        {loaiThongKe: "Tổng Dân số trong quận/ huyện"},
        {loaiThongKe: "Tổng số hộ"},
        {loaiThongKe: "Số hộ có nhà tiêu"},
        {loaiThongKe: "Số hộ có nhà tiêu hợp vệ sinh (HVS)"},
        {loaiThongKe: "Tỉ lệ % hộ có nhà tiêu HVS"},
        {loaiThongKe: "Số hộ có nhà tiêu HVS mới được xây dựng trong kỳ báo cáo"},
        {loaiThongKe: "Số hộ có nhà tiêu  bị xuống cấp thành nhà tiêu không HVS trong kỳ b/ cáo"},
      ];
      baoCao.value.chiTietMotSoLoaiNhaTieu = [
        {loaiNhaTieu: "Tổng số nhà tiêu",chiTiet: {}},
        {loaiNhaTieu: "Số nhà tiêu HVS",chiTiet: {}},
        {loaiNhaTieu: "Tỉ lệ % HVS (so với tổng số nhà tiêu tự hoại)",chiTiet: {}},
        {loaiNhaTieu: "Số nhà tiêu HVS mới được xây dựng trong kỳ báo cáo",chiTiet: {}},
        {loaiNhaTieu: "Số nhà tiêu  bị xuống cấp thành nhà tiêu không HVS trong kỳ b/ c",chiTiet: {}},
      ];

      baoCao.value.truyenThongGiaoDucs = [
        {hinhThucTruyenThong: "Tập huấn", loai: " lớp", loaiNguoi: " người"},
        {hinhThucTruyenThong: "Mít ting", loai: " buổi", loaiNguoi: " người"},
        {hinhThucTruyenThong: "Tư vấn", loai: " lần", loaiNguoi: " người"},
        {hinhThucTruyenThong: "Nói chuyện", loai: " buổi", loaiNguoi: " người"},
        {hinhThucTruyenThong: "Phát thanh", loai: " lần"},
        {hinhThucTruyenThong: "Phát truyền hình", loai: " lần"},
        {hinhThucTruyenThong: "Pano, áp phích", loai: " chiếc"},
        {hinhThucTruyenThong: "Tờ rơi", loai: " tờ"},
      ];

    }
    initDb();

    const addReport = () => {
      if(baoCao.value.loaiBaoCao.length < 1)
      {
        toast.add({
          severity: 'error',
          summary: 'Lỗi',
          detail:'Vui lòng chọn thời gian báo cáo',
          life: 2000
        });
      }
      else {
        CDCRepository.createBaoCaoVSNuocSach(baoCao.value)
            .then((response) => {
              const temp = ref({} as BaoCaoVeSinhNuocSach);
              baoCao.value = temp.value;
              initDb();
              toast.add({
                severity: 'success',
                summary: 'Thêm báo cáo',
                detail: 'Thêm báo cáo thành công vào hệ thống',
                life: 2000
              });
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail: err.response.data,
                life: 2000
              });
            });
      }
    }

    return {
      date,
      service,
      addReport,
      baoCao,
      // addHoSo
    }
  }

}
